import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


const About = () => {



  return (
    <div>

      <div className='mt-10 text-center px-3' data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="350">
        <h1 className='text-xl font-bold underline text-main'>
          קצת עליי
        </h1>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          היי אני מירה ,
          לטפח נשים זה הסיפוק הכי גדול שלי.        </p>

        <p className='text-lg font-normal max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main' dir='rtl'>
          תחום הקוסמטיקה דיבר אליי מגיל צעיר מאד. תמיד אהבתי להיראות מטופחת וזוהרת אבל לא עשיתי עם זה הרבה.         </p>
        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>
          אני מאמינה שצריך להיות בן אדם ישר לפני הכל וכל השאר מגיע מלמעלה 🙏
        </p>



        <p className='text-lg max-w-md mx-auto lg:max-w-2xl rtl font-normal px-2 text-main' dir='rtl'>

          מחכה לכן ב ❤️
        </p>

        <p className='text-lg font-bold max-w-md mx-auto lg:max-w-2xl rtl  px-2 text-main' dir='rtl'>

          מזמינה אתכם ליצור קשר בקליק.               </p>
      </div>

    </div>

  )

}


export default About